<template>
    <div>
        <Header></Header>

        <section class="section section--header">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-6 offset-md-6">
                        <h1 class="mt-0">Află mai multe despre<br> prima factură</h1>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section--subheader">
            <div class="container">
                <div class="container-950">
                    <div class="row">
                        <div class="col-12 text-center">
                            <p>
                                Fie că ai un abonament nou sau ai prelungit contractul cu Vodafone, noi ne bucurăm și îți mulțumim pentru alegerea făcută!
                            </p>
                            <p>
                                Pentru Vodafone este important ca tu să ai o experiență bună. De aceea, vrem să subliniem că prima factură cu noul abonament poate fi puțin diferită.
                            </p>
                            <p>
                                De ce? Pentru că, de cele mai multe ori, ziua în care accepți oferta și activezi abonamentul nu coincide cu data de facturare. În continuare, am explicat componentele unei prime facturi, în caz că ai nevoie să o înțelegi mai bine.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section--factura-steps">
            <div class="container">
                <div class="container-950">
                    <div class="row">
                        <div class="col-12 text-left text-sm-center">
                            <h2>Prima factură</h2> 
                        </div>
                    </div>
                    <div class="row">
                        <tabs class="col-12" @changed="tabChanged" :options="{ useUrlFragment: false }" cache-lifetime="0">
                            <tab id="abonament-nou" class="row" name="Abonament nou">
                                <!-- <div class="col-sm-6">
                                    <div class="steps-side steps-side--left justify-content-md-end">
                                        <div class="step-icon order-md-1">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/document-mid.png">
                                        </div>
                                        <div class="step-text-description text-md-right order-md-0">
                                            <p><strong>Prima factură</strong> se va emite în data de facturare specificată pe <br class="d-none d-lg-block">contractul încheiat la momentul activării abonamentului</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div> -->
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/document-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p><strong>Prima factură</strong> se va emite în data de facturare specificată pe <br class="d-none d-lg-block">contractul încheiat la momentul activării abonamentului</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/sim-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>Va conține valoarea <strong>abonamentului</strong> începȃnd cu ziua de cȃnd <br class="d-none d-lg-block">a fost activat și pȃnă la data de facturare</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/calendar-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>Valoarea <strong>ratei telefonului</strong> începȃnd cu data procesării <br class="d-none d-lg-block">comenzii</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/make_payment_mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>Și valoarea integrală a <strong>abonamentului + rată telefon</strong> pentru <br class="d-none d-lg-block">luna în curs</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/chart-bar-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>De asemenea, se mai pot regăsi reduceri pentru abonamentul achiziţionat sau eventuale <strong>costuri suplimentare</strong></p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/case-study-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>Urmatoarele <strong>facturi</strong> vor include doar plata abonamentului lunar, rata și eventualele costuri suplimentare</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/unified-communication-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>
                                                Dacă ai nevoie de detalii, verifică factura ta în aplicația mobilă <a onclick="dataLayer.push({'event' : 'microData', 'event_name' : 'action_click', 'click_element_name' :'My Vodafone app link - Abonament nou', 'page_name' : 'Prima factura dupa reinnoire LP'})" target="_blank" style="text-decoration:underline;color: #e60000" href="https://bit.ly/factura-vodafone">My Vodafone</a> sau pe site-ul <a onclick="dataLayer.push({'event' : 'microData', 'event_name' : 'action_click', 'click_element_name' :'My Vodafone web link - Abonament nou', 'page_name' : 'Prima factura dupa reinnoire LP'})" target="_blank" style="text-decoration:underline;color: #e60000" href="https://www.vodafone.ro/vfrointegration/appmanager/vfroportal/myvodafone?_nfxr=false&_pageLabel=contul-meu">Vodafone</a></a>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <section-exemple>
                                    <template v-slot:modal-header>
                                        <h2 style="line-height: 30px">Exemplu factură <br>
                                            <span style="font-size: 24px;">emisă pe 8 noiembrie 2020</span>
                                        </h2> 
                                    </template>
                                    <template v-slot:modal-img-trigger>
                                        <img class="img-fluid bill-example-img" src="https://static.vodafone.ro/prima-factura/assets/images/factura-abo-nou.png">
                                    </template>
                                    <template v-slot:modal-content>
                                        <p><span><strong>A</strong></span> se referă la valoarea abonamentului achiziționat. Perioada 21 octombrie - 7 noiembrie reprezintă valoarea serviciilor de când am activat abonamentul și pâna la data de facturare. Perioada 8 noiembrie - 7 decembrie reprezintă valoarea serviciilor pentru luna în curs.</p>
                                        <p><span><strong>B</strong></span> se referă la valoarea ratei la telefon (TVA inclus) conform abonamentului achiziționat. Perioada 21 octombrie - 7 noiembrie reprezintă valoarea ratei de cand am activat abonamentul și pâna la data de facturare. Perioada 8 noiembrie - 7 decembrie se referă la valoarea ratei pentru luna în curs.</p>
                                    </template>
                                    <template v-slot:modal-img-popup>
                                        <img class="img-fluid w-100" src="https://static.vodafone.ro/prima-factura/assets/images/factura-abo-nou.png">
                                    </template>
                                </section-exemple>
                            </tab>
                            <tab id="reinnoire-abonament" class="row" name="Reînnoire abonament">
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/document-mid.png">
                                        </div>
                                        <div class="step-text-description ">
                                            <p><strong>Prima factură</strong> se va emite<br class="d-none d-lg-block">în aceeași zi în care te-ai obișnuit</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/sim-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>Va conține valoarea <strong>noului abonament</strong> începând<br class="d-none d-lg-block"> cu ziua în care l-ai activat</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/calendar-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>Valoarea <strong>ratei telefonului</strong><br class="d-none d-lg-block"> începând cu ziua în care ai acceptat oferta</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/make_payment_mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>Și valoarea integrală a <strong>abonamentului + rată telefon</strong><br class="d-none d-lg-block"> pentru prima lună întreagă</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/chart-bar-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>De asemenea, mai pot fi incluse eventualele <strong>diferențe de plată</strong> din momentul trecerii la noul abonament</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/case-study-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>Următoarele <strong>facturi</strong> vor include abonamentul și rata telefonului doar pe luna în curs.</p>
                                        </div>
                                        <div class="progressbar-stripe progressbar-stripe--down"></div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="steps-side steps-side--right">
                                        <div class="progressbar-stripe progressbar-stripe--up"></div>
                                        <div class="step-icon">
                                            <img src="https://static.vodafone.ro/prima-factura/assets/images/unified-communication-mid.png">
                                        </div>
                                        <div class="step-text-description">
                                            <p>
                                                Dacă ai nevoie de detalii, verifică factura ta în aplicația mobilă <a onclick="dataLayer.push({'event' : 'microData', 'event_name' : 'action_click', 'click_element_name' :'My Vodafone app link - Reinnoire abonament', 'page_name' : 'Prima factura dupa reinnoire LP'})" style="text-decoration:underline;color: #e60000" href="https://bit.ly/factura-vodafone">My Vodafone</a> sau pe site-ul <a onclick="dataLayer.push({'event' : 'microData', 'event_name' : 'action_click', 'click_element_name' :'My Vodafone web link - Reinnoire abonament', 'page_name' : 'Prima factura dupa reinnoire LP'})" style="text-decoration:underline;color: #e60000" href="https://www.vodafone.ro/vfrointegration/appmanager/vfroportal/myvodafone?_nfxr=false&_pageLabel=contul-meu">Vodafone</a>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <section-exemple>
                                    <template v-slot:modal-header>
                                        <h2 style="line-height: 30px">Exemplu factură <br>
                                            <span style="font-size: 24px;">emisă pe 8 august 2020</span>
                                        </h2> 
                                    </template>
                                    <template v-slot:modal-img-trigger>
                                        <img class="img-fluid bill-example-img" src="https://static.vodafone.ro/prima-factura/assets/images/Factura-new.png">
                                    </template>
                                    <template v-slot:modal-content>
                                        <p><span><strong>A</strong></span> reprezintă returnarea valorii abonamentului dezactivat în data de 7 august (o zi).</p>
                                        <p><span><strong>B</strong></span> se referă la valoarea noului abonament. Perioada 7 august reprezintă valoarea serviciilor de când oferta a fost activată și până la facturare. Perioada 8 august - 7 septembrie reprezintă valoarea serviciilor pentru luna în curs.</p>
                                        <p><span><strong>C</strong></span> se referă la valoarea ratei la telefon (TVA inclus) conform ofertei acceptate. Perioada 23 iulie - 7 august reprezintă valoarea ratei de când oferta a fost acceptată și pâna la data de facturare. Perioada 8 august - 7 septembrie se referă la valoarea ratei pentru luna în curs.</p>
                                    </template>
                                    <template v-slot:modal-img-popup>
                                        <img class="img-fluid w-100" src="https://static.vodafone.ro/prima-factura/assets/images/Factura-new.png">
                                    </template>
                                </section-exemple>
                            </tab>
                        </tabs>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section--feedback">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3>A fost utilă informația?</h3>
                    </div>
                    <div class="col-12">
                        <div v-if="!isVisible" class="d-flex justify-content-center">
                            <button :disabled="disabled" @click="sendFeedback('da')" type="button">
                                <img width="24" height="24" src="https://static.vodafone.ro/prima-factura/assets/images/feedback-true.svg" alt="">
                            </button>
                            <button :disabled="disabled" @click="sendFeedback('nu')" type="button">
                                <img width="24" height="24" src="https://static.vodafone.ro/prima-factura/assets/images/feedback-false.svg" alt="">
                            </button>
                        </div>
                        <div v-else>
                            <p class="text-center mb-0">
                                Mulțumim pentru feedback.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../../../../components/Header';
    import Footer from '../../../../components/Footer';
    import SectionExemple from './SectionExemple';
    const axios = require('axios').default;
    const qs = require('qs');
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    
    export default {
        name: 'app',
        components: {
            Header,
            Footer,
            SectionExemple
        },
        data(){
            return {
                isVisible: false,
                disabled: false,
            }
        },
        methods: {
            setCookie(cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays*24*60*60*1000));
                var expires = "expires="+ d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },
            getCookie(cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for(var i = 0; i <ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                    }
                }
                return "";
            },
            sendFeedback(val) {
                this.disabled = true;   
                this.setCookie('feedback', true, 30);

                var today = new Date(),
                    dd = String(today.getDate()).padStart(2, '0'),
                    mm = String(today.getMonth() + 1).padStart(2, '0'), //January is 0!
                    yyyy = today.getFullYear();

                today = mm + '/' + dd + '/' + yyyy;

                axios({
                    method: 'post',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },
                    url: 'https://www.vodafone.ro/system/webforms/submit/index.htm',
                    data: qs.stringify({
                        'formId': '449',                    
                        'EmailId': '1',
                        'Vot': val,
                        'Data': today
                    })
                })
                .then(response => {
                    
                    if (response.status == 200) {
                        this.isVisible = true
                    }
                }).catch(errors => {
                    
                })
            },
            tabChanged (selectedTab) {
                dataLayer.push({
                    "event" : "microData",
                    "event_name" : "action_click",
                    "click_element_name" : selectedTab.tab.name + " - Tab",
                    "page_name" : "Prima factura dupa reinnoire LP" 
                });
            },
        },
        mounted() {
            if (this.getCookie('feedback')) {
                this.isVisible = true
            }
        }
    }
</script>
